import React from "react";
import styled from "styled-components";
import Navigation from "../components/Header/nav";
import image1 from "../images/FeaturedProjects/Transcendance/kam2.png";
import doctran from "../images/FeaturedProjects/Transcendance/doctran.gif";
import trangif from "../images/FeaturedProjects/Transcendance/Tran.gif";
import tran2 from "../images/FeaturedProjects/Transcendance/tran2.jpg";
import RevealOnScroll from "../utils/RevealOnScroll";
import YouTubePreloader from '../utils/YouTubePreloader';
import TextShift from "../utils/TextShift";

// Styled Components
const PageWrapper = styled.div`
  width: 60%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;

  @media (max-width: 768px) {
    width: 95%;
    padding: 0.5rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

const SectionTitle = styled.h2`
  color: white;
  font-family: "Maitree", sans-serif;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
`;

const SectionText = styled.p`
  color: #b5b5b5;
  font-family: "Maitree", sans-serif;
  line-height: 1.6;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.5;
    margin-bottom: 0.75rem;
  }
`;

const MediaContainer = styled.div`
  width: 100%;
  margin: 1rem 0;

  iframe {
    width: 100%;
    height: 500px;
    border-radius: 8px;
  }
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 1rem;
  }

  @media (max-width: 768px) {
    margin: 0.5rem 0;
    
    iframe {
      height: 300px;
    }
    
    img {
      margin-bottom: 0.5rem;
    }
  }
`;

const HorizontalImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;

  img {
    width: calc(50% - 0.5rem);
    height: auto;
    border-radius: 8px;
    object-fit: cover; /* Maintain aspect ratio without stretching */
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;

    img {
      width: 100%;
      margin-bottom: 0;
    }
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
`;

const Transcendence = () => {
  return (
    <div>
      <PageWrapper>
        <RevealOnScroll delay={0.2}>
          <TitleWrapper>
            <TextShift 
              text="Transcendence" 
              fontFamily="moret-variable"
              fontSize={"2rem"}
            />
          </TitleWrapper>
          {/* Video and Wide Images Section */}
          <Section>
            <MediaContainer>
              <YouTubePreloader 
                videoId="eSlhU9OXky8" 
                title="Transcendence Demo"
              />
              <img src={image1} alt="Transcendence Image 1" />
              <img src={trangif} alt="Transcendence GIF" />
            </MediaContainer>
          </Section>

          {/* Vertical Images Section */}
          <Section>
            <HorizontalImageContainer>
              <img src={tran2} alt="Transcendence Image 2" />
              <img src={doctran} alt="Transcendence GIF 2" />
            </HorizontalImageContainer>
          </Section>

          {/* Text Sections */}
          <Section>
            <SectionTitle>Overview</SectionTitle>
            <SectionText>
              Transcendence (noun) (Philosophy) In existentialist thought, the
              act of surpassing the limits of one's facticity—the given,
              unchangeable circumstances of one's life such as birth,
              socio-economic status, and historical context. It is the process
              by which an individual can go beyond their predetermined nature
              through their own conscious choices, actions, and will.
            </SectionText>
            <SectionText>
              The concept of "Transcendence" as a live interactive installation
              project carries a commentary on identity, individualism, and
              determinism. By capturing the images of passersby with the overlay
              "I AM NOT MY MAKER," it simultaneously acknowledges the
              individual's journey beyond their inherited identity while also
              emphasizing a collective human experience that transcends
              birthright and genetic
            </SectionText>
            <SectionText>
              This installation confronts the viewer with the paradox of
              striving for individuality in a world that often seeks to
              categorize and generalize, suggesting that while our decisions
              carve out our unique paths, there is an underlying sameness to the
              human condition. The phrase "I AM NOT MY MAKER" serves as a
              reminder of our agency in defining who we become, resisting the
              deterministic view that our origins predetermine our destinies.
            </SectionText>
          </Section>
          <Section>
            <SectionTitle>Exhibitions</SectionTitle>
            <SectionText>- DASA, Year end show, 2023</SectionText>
            <SectionText>- Sandbox, Art collective, 2024</SectionText>
          </Section>
        </RevealOnScroll>
      </PageWrapper>
    </div>
  );
};

export default Transcendence;
